import { create } from 'zustand';

export type ChatWindowStore = {
  position: {
    left: number;
    bottom: number;
  };
  setPosition: (position: { left: number; bottom: number }) => void;
};

export const useChatWindowStore = create<ChatWindowStore>((set) => ({
  position: { left: 10, bottom: 80 },
  setPosition: (position) => set({ position }),
}));
